import type { FilterFunc, SearchSummary } from '@tunasong/models'
import type { SearchIntent } from '@tunasong/redux'
import type { Entity, SearchRequest } from '@tunasong/schemas'
import { SearchResults, type SearchResultsProps } from './search-results.js'
import { useAdvancedSearch } from './search.hook.js'

export interface SearchListProps
  extends Omit<SearchResultsProps, 'entities' | 'onChange' | 'onEndOfResults' | 'inputRef'> {
  query?: SearchRequest

  /**
   * What `query` means, for a host that cannot execute OpenSearch DSL. A list that does
   * not supply it is answered from the DSL only, which a local kernel cannot do — so it
   * comes back empty. Search folders (`plugins/searchfolder`) are the deliberate case:
   * they persist a cloud-authored DSL with no intent behind it (spec §3 residue).
   */
  intent?: SearchIntent

  /** Fetch size for getNext */
  fetchSize?: number
  inputRef?: HTMLElement | null
  resultFilter?: FilterFunc
  selected?: Pick<Entity, 'id'>
  onChange(summary: SearchSummary): void
}

export function SearchList(props: SearchListProps) {
  const { query, intent, fetchSize, inputRef, resultFilter, onChange, selected, ...restProps } = props

  /** @todo filter on type */
  const { results, searching, getNext } = useAdvancedSearch(query, {
    resultFilter,
    debounceDelay: 0,
    size: fetchSize,
    queryType: 'type',
    intent,
  })

  return (
    <SearchResults
      {...restProps}
      searching={searching}
      inputRef={inputRef}
      entities={results}
      onChange={onChange}
      onEndOfResults={getNext}
      selectedIndex={results.findIndex(r => r.id === selected?.id)}
    />
  )
}
